import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { FormattedMessage } from "react-intl";
import img1 from "../../assets/images/dreamRobot/img1.png";
import img2 from "../../assets/images/dreamRobot/img2.png";
import img3 from "../../assets/images/dreamRobot/img3.png";
import img4 from "../../assets/images/dreamRobot/img4.png";
import img5 from "../../assets/images/dreamRobot/img5.png";

const pStyle = {
  fontSize: "18px",
  marginBottom: "16px"
};

export default function DreamRobotGuide() {
  return (
    <Box>
      <Typography component="p" sx={pStyle} className="text">
        <FormattedMessage
          id="dreamRobot.step1"
          values={{
            b: (...chunks) => {
              return <b style={{ fontWeight: "500" }}>{chunks}</b>;
            },
            br: <br />
          }}
        />
      </Typography>
      <img alt="Dream Robot Step 1" src={img1} style={{ width: "100%" }} />
      <br />
      <br />
      <Typography component="p" sx={pStyle}>
        <FormattedMessage
          id="dreamRobot.step2"
          values={{
            b: (...chunks) => {
              return <b style={{ fontWeight: "500" }}>{chunks}</b>;
            },
            br: <br />
          }}
        />
      </Typography>
      <img alt="Dream Robot Step 2" src={img2} style={{ width: "100%" }} />
      <br />
      <br />
      <Typography component="p" sx={pStyle}>
        <FormattedMessage
          id="dreamRobot.step3"
          values={{
            b: (...chunks) => {
              return <b style={{ fontWeight: "500" }}>{chunks}</b>;
            },
            br: <br />
          }}
        />{" "}
        <img alt="Dream Robot Step 3" src={img3} style={{ width: "100%" }} />
        <br />
        <br />
      </Typography>{" "}
      <Typography component="p" sx={pStyle}>
        <FormattedMessage
          id="dreamRobot.step4"
          values={{
            b: (...chunks) => {
              return <b style={{ fontWeight: "500" }}>{chunks}</b>;
            },
            br: <br />
          }}
        />{" "}
        <img alt="Dream Robot Step 4" src={img4} style={{ width: "100%" }} />
        <br />
        <br />
      </Typography>{" "}
      <Typography component="p" sx={pStyle}>
        <FormattedMessage
          id="dreamRobot.step5"
          values={{
            b: (...chunks) => {
              return <b style={{ fontWeight: "500" }}>{chunks}</b>;
            },
            br: <br />
          }}
        />
      </Typography>{" "}
      <img alt="Dream Robot Step 5" src={img5} style={{ width: "100%" }} />
    </Box>
  );
}
